import { TableHeadersType } from "./tableHeadersType";

export const SOP_MODULE_HEADERS: TableHeadersType[] = [
  {
    label: "File Name",
    value: "file_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "updated_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];

export const SOP_REPORTS_MODULE_HEADERS: TableHeadersType[] = [
  {
    label: "CLIENT NAME",
    value: "client_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "FILE NAME",
    value: "file_name",
    defaultChecked: true,
    checked: true,
  },
 
  {
    label: "ADDED/MODIFIED BY",
    value: "updated_by",
    defaultChecked: true,
    checked: true,
  }
];
